import { render, staticRenderFns } from "./FundsBank.vue?vue&type=template&id=868c5962&scoped=true&"
import script from "./FundsBank.vue?vue&type=script&lang=js&"
export * from "./FundsBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868c5962",
  null
  
)

export default component.exports